// Named regular customers from the leaflet. We render their names in a
// styled marquee since most have no public brand-logo asset.
export const customers = [
  { name: "Kamoto Copper Company" },
  { name: "Mutanda Mining SARL" },
  { name: "Kamoa Copper Mining" },
  { name: "ERG Liberty" },
  { name: "Tengyuan Copper & Cobalt Resources (TCC)" },
  { name: "Kambove Mining" },
  { name: "Thomas Mining" },
  { name: "Brother Mining" },
];
